import { removeHtmlTags } from '../../../pages/groups-dashboard/ReportingGroup/utils'

const ClozeAnswer = ({ ...props }) => {
    const question = props.answerChoices[0]._answer ?? []
    const userAnswer = props.userAnswer.answer_data ? JSON.parse(props.userAnswer.answer_data ) : []

    const split = removeHtmlTags( question.replaceAll("{","('").replaceAll("}","')") )

    return (
        <div className='msync-question-container__answer__clozeanswer'>
            { 
                split.split("('").map((substr, index) => {
                    return index < userAnswer.length ? (
                        <>
                            { substr }
                            <input type="text" value={`${userAnswer[index]}`} disabled />
                            {` ('`}
                        </>
                    ) : substr
                })
            }
        </div>
    )
}

export default ClozeAnswer